<template>
  <div :class="size == 'sm' ? 'small' : ''">
    <div v-if="membership">
      <i :class="`fa fa-fw fa-${membership ? 'id-card' : 'user'}`" :title="trans('membership')"></i>
      {{ membership.name }}
      <span v-if="!!membership.expired_at">
        ({{ moment(membership.expired_at).format('LL') }})
        <span v-if="moment().isAfter(membership.expired_at)" class="text-danger">
          {{ trans('expired') }}!
        </span>
      </span>
      <b-button
        v-if="!!membershipNoteHtml"
        variant="link"
        size="sm"
        class="text-muted py-0"
        :title="trans('note')"
        @click="onClickNote"
      >
        <i class="fa fa-fw fa-comment"></i>
      </b-button>
      <b-button
        v-if="memberUrl"
        variant="link"
        size="sm"
        class="text-muted py-0"
        :title="trans('member')"
        :href="memberUrl"
        target="_blank"
      >
        <i class="fa fa-fw fa-external-link-alt"></i>
      </b-button>
    </div>
    <div v-if="!membership" class="text-muted">
      <i class="fa fa-fw fa-id-card"></i>
      {{ trans('no_membership') }}
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      membership: Object,
      memberEmail: String,
      size: {
        type: String,
        default: null, // sm or null
      },
      showMemberUrl: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        moment: moment,
      }
    },
    computed: {
      memberUrl() {
        if (!this.organization ||
          !this.showMemberUrl ||
          !this.membership)
          return null
        let membership_id = this.membership.membership_id || this.membership.id
        let url = !!membership_id ? 
          `/organization/${this.organization.id}/membership/${membership_id}` :
          `/organization/${this.organization.id}/membership/members`
        if (this.membership.recipient_id)
          return `${url}?name=${this.membership.recipient_id}`
        if (!!this.memberEmail)
          return `${url}?email=${encodeURIComponent(this.memberEmail)}`
        return null
      },
      membershipNoteHtml() {
        if (!this.membership || !this.membership.membership_note) return null
        return this.membership.membership_note
      },
    },
    methods: {
      onClickNote() {
        let msg = this.$createElement('div', {domProps: {innerHTML: this.membershipNoteHtml}})
        this.$bvModal.msgBoxOk([msg], {
          title: trans('note'),
          okTitle: trans('close'),
        })
      },
    },
  }
</script>